import script from "./HotelImageCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelImageCarousel.vue?vue&type=script&setup=true&lang=js"

import "./HotelImageCarousel.vue?vue&type=style&index=0&id=0b2ec202&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b2ec202"]])

export default __exports__